import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const team = [{
  name: 'Alex Lazich',
  role: 'Founder & CEO',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/alex-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/alex-lazich-558824118/'
}, {
  name: 'Jesse Williams',
  role: 'Founder & CTO',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/jesse-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/jessewilliams3/'
}, {
  name: 'Ben Folks',
  role: 'Founder & Engineer',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/ben-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/ben-folks-595b7139/'
}, {
  name: 'Emily Nucci',
  role: 'Implementations',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/99f88e77-15e9-4ff9-84fe-4a0cd45b378d/emily-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/emily-n-b12854191/'
}];
export function AboutUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-violet-electric/30 pt-32 pb-20" data-id="element-348">
      {/* Hero */}
      <section id="hero" className="relative px-6 mb-32" data-id="element-349">
        <div className="max-w-4xl mx-auto text-center" data-id="element-350">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-351">

            Why Thruline
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8" data-id="element-352">

            The amazing team behind our company
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-white/60 max-w-2xl mx-auto leading-relaxed" data-id="element-353">

            Our team's experience across manufacturing verticals gives us the
            insight to know and understand what makes your organization unique.
          </motion.p>
        </div>
      </section>

      {/* Team Grid */}
      <section id="team" className="px-6 mb-32" data-id="element-354">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-355">
          {team.map((member, index) => <motion.div key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center group" data-id="element-356">

              <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white/5 group-hover:border-violet-electric/50 transition-colors duration-300" data-id="element-357">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-all duration-500" data-id="element-358" />

              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-359">{member.name}</h3>
              <p className="text-white/60 mb-4" data-id="element-360">{member.role}</p>
              <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/5 hover:bg-violet-electric hover:text-white transition-colors text-white/40" data-id="element-361">

                <LinkedinIcon className="w-4 h-4" data-id="element-362" />
              </a>
            </motion.div>)}
        </div>
      </section>

      {/* Mission */}
      <section id="mission" className="px-6" data-id="element-363">
        <div className="max-w-4xl mx-auto text-center bg-white/[0.02] border border-white/10 rounded-3xl p-12 md:p-20 relative overflow-hidden" data-id="element-364">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-violet-electric via-magenta-hot to-violet-electric" data-id="element-365" />

          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-366">Our Mission</h2>
          <p className="text-2xl md:text-3xl text-white/80 font-light leading-relaxed mb-12" data-id="element-367">
            Building the first ERP Factory for the physical world
          </p>

          <Link to="/resources/thesis" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-navy font-semibold text-base hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10" data-id="element-368">

            Read Our Thesis
            <ArrowRightIcon className="w-4 h-4" data-id="element-369" />
          </Link>
        </div>
      </section>
    </div>;
}